export const generatedId = () => Math.random().toString(36).substring(2, 9);
